import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import LineString from "ol/geom/LineString";
import MultiLineString from "ol/geom/MultiLineString";
import { Vector as VectorLayer } from "ol/layer";
import LayerGroup from "ol/layer/Group";
import { FairwayListDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { fairwayDtoToFairwayData } from "./dataConverters";

export function addFairwaysToMap(map: Map, fairways: FairwayListDto[]): void {
  // Find the fairway layer and add the fairways as features
  map.getLayers().forEach((l) => {
    if (l instanceof LayerGroup) {
      l.getLayers().forEach((lay) => {
        if (
          lay.get("title") === LayerTitle.Fairways &&
          lay instanceof VectorLayer
        ) {
          const source = lay.getSource();
          // Clear the source before adding
          source.clear();
          const features: Feature<Geometry>[] = [];
          fairways.forEach((f) => {
            // Convert to internal type
            const convertedFairway = fairwayDtoToFairwayData(f);
            const location = new MultiLineString(
              convertedFairway.location.map(
                (line) => new LineString(line.map((c) => [c.x, c.y])),
              ),
            );
            const feat = new Feature({
              geometry: location,
            });
            feat.setProperties({ ...convertedFairway });
            feat.setId(convertedFairway.mapId);
            features.push(feat);
          });
          source.addFeatures(features);
          source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
          map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
        }
      });
    }
  });
}
